(() => {
  'use strict';
  const shapes = ['Round Brilliant','Oval','Pear','Radiant','Marquise','Princess','Emerald','Asscher','Cushion','Trillion','Baguette','Tapered Baguette','Half Moon','Hexagon','Lozenge','Heart','Shield','Cross'];
  const slug = value => String(value).trim().toLowerCase().replace(/[\s_]+/g, '-');
  const shapeName = value => {
    const names = String(value || '').split(/\s*(?:,|\+|\band\b)\s*/i).map(part => shapes.find(item => slug(item) === slug(part) || (item === 'Round Brilliant' && slug(part) === 'round')));
    return names.length && names.every(Boolean) ? names.join(' + ') : '';
  };
  const describedShapes = value => {
    const names = String(value || '').match(/round brilliant|tapered baguette|half moon|oval|pear|radiant|marquise|princess|emerald|asscher|cushion|trillion|baguette|hexagon|lozenge|heart|shield|cross/gi) || [];
    return [...new Set(names.map(shapeName).filter(Boolean))].join(' + ');
  };
  const parse = (value, specs) => {
    const parts = String(value).trim().split(/\s+\/\s+/);
    const result = {};
    const unclassified = [];
    parts.forEach(part => {
      const shape = shapeName(part);
      if (shape && !result.shape) result.shape = shape;
      else if (/\bby request\b|(?:\d|\.)\s*(?:ct|carat)|(?:ctw|carats?)\b/i.test(part) && !result.caratWeight) result.caratWeight = part;
      else if (/^\d.*(?:["”″]|mm\b|cm\b|\binches\b)/i.test(part)) result.length = part;
      else if (!/^original$/i.test(part)) unclassified.push(part);
    });
    if (specs) {
      if (!result.shape) result.shape = describedShapes(specs['Diamond shape'] || specs['Gemstone shape'] || specs['Diamond composition']);
      if (!result.caratWeight) result.caratWeight = specs['Carat weight per earring'] || specs['Total carat weight'] || specs['Total diamond weight'] || '';
    }
    if (unclassified.length) result.version = unclassified.join(' / ');
    if (!result.shape && !result.caratWeight && !specs) return null;
    return result;
  };
  const weight = value => {
    const match = value.replace(/^.*=\s*/, '').replace(/(\d),(\d)/g, '$1.$2').match(/^(\d*(?:\.\d+)?)(?:\s*\/\s*(\d+))?/);
    return match?.[1] ? Number(match[1]) / Number(match[2] || 1) : Infinity;
  };
  const caratCaption = value => value.replace(/^.*=\s*/, '').replace(/\s*\([^)]*\)\s*$/, '').replace(/(\d),(\d)/g, '$1.$2').replace(/(\d)(ct)/gi, '$1 $2').trim();
  const normalize = (config, labels) => {
    if (!config?.axes || !config.records?.length) return config;
    let records = config.records;
    const axes = config.axes.flatMap(axis => {
      if (!/^(design|configuration)$/i.test(axis.key)) return [axis];
      const parsed = records.map(record => parse(record.selections?.[axis.key] || record.design, record.specs || {}));
      if (config.axes.some(item => item !== axis && /^(shape|diamondType|caratWeight)$/i.test(item.key))) return [axis];
      const byDesign = new Map();
      parsed.forEach((item,index) => {
        const key = records[index].design;
        const known = byDesign.get(key) || {};
        Object.entries(item).forEach(([name,value]) => { if (value && !known[name]) known[name] = value; });
        byDesign.set(key, known);
      });
      parsed.forEach((item,index) => Object.assign(item, byDesign.get(records[index].design)));
      const keys = ['shape','caratWeight','length','version'].filter(key => parsed.some(item => item[key]));
      if (keys.includes('caratWeight')) parsed.forEach(item => { item.caratWeight ||= labels.byRequest; });
      const combinations = new Map();
      parsed.forEach((item,index) => {
        const key = JSON.stringify([records[index].metal, keys.map(key => item[key] || '')]);
        if (combinations.has(key) && combinations.get(key) !== records[index].design) {
          if (!keys.includes('version')) keys.push('version');
          parsed.forEach((item,index) => { item.version = records[index].design; });
        }
        combinations.set(key, records[index].design);
      });
      records = records.map((record, index) => {
        const selections = { ...record.selections, ...parsed[index] };
        delete selections[axis.key];
        return { ...record, selections };
      });
      const values = key => [...new Set(parsed.map(item => item[key]).filter(Boolean))].sort(key === 'caratWeight' ? (a,b) => weight(a) - weight(b) : key === 'shape' ? (a,b) => shapes.indexOf(a) - shapes.indexOf(b) : undefined).map(value => ({ value, label: key === 'caratWeight' ? caratCaption(value) : value }));
      return keys.map(key => ({ key, label: labels[key] || labels.model, values: values(key) }));
    }).map(axis => /^(shape|diamondType)$/.test(axis.key) ? { ...axis, label: labels.shape } : /^(carat|caratWeight|carat_weight)$/.test(axis.key) ? { ...axis, label: labels.caratWeight } : axis);
    return { ...config, axes, records };
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = { parse, normalize }; return; }
  const source = document.getElementById('JBFirstProductLabels');
  if (!source) return;
  let settings;
  try { settings = JSON.parse(source.textContent); } catch { return; }
  if (settings.stoneOptionsEnabled === false) return;
  const labels = settings.controls;
  const imageFor = value => {
    const images = String(value).split(' + ').map(part => document.getElementById('JBStoneShapeImages')?.content.querySelector('[data-shape="' + slug(part) + '"] .jb-shape-images')?.cloneNode(true)).filter(Boolean);
    if (images.length < 2) return images[0];
    const group = document.createElement('span'); group.className = 'jb-shape-images jb-shape-images--pair'; group.setAttribute('aria-hidden','true');
    images.forEach(image => group.append(...image.children)); return group;
  };
  const fieldFor = (axis, catalog) => {
    const field = document.createElement('fieldset');
    field.className = catalog ? 'jb-catalog-axis jb-stone-option-field' : 'jb-stone-option-field';
    if (catalog) field.dataset.jbAxisField = axis.key;
    field.dataset.jbStoneKey = axis.key;
    const legend = document.createElement('legend'); legend.className = 'form__label'; legend.textContent = axis.label;
    const group = document.createElement('div'); group.className = 'jb-catalog-axis__buttons jb-stone-option-buttons';
    group.style.setProperty('--jb-control-columns', String(Math.min(3, axis.values.length)));
    axis.values.forEach(value => {
      const button = document.createElement('button'); button.type = 'button'; button.dataset.jbValue = value.value;
      if (catalog) button.dataset.jbAxis = axis.key;
      button.setAttribute('aria-pressed', 'false');
      if (axis.key === 'shape') { const image = imageFor(value.value); if (image) button.append(image); }
      const caption = document.createElement('span'); caption.textContent = value.label; button.append(caption); group.append(button);
    });
    field.append(legend, group); return field;
  };
  const prepareCatalogs = () => {
    document.querySelectorAll('script[data-jb-ring-catalog-manifest]:not([data-jb-stone-prepared])').forEach(node => {
      let manifest;
      try { manifest = JSON.parse(node.textContent); } catch { return; }
      const root = [...document.querySelectorAll('.jb-product-experience')].find(item => item.dataset.handle === node.dataset.handle);
      const controls = root?.querySelector('[data-jb-catalog-controls]');
      if (!controls || root.dataset.jbCatalogReady) return;
      const config = normalize(manifest.configuration, labels);
      config.axes.forEach(axis => {
        const old = [...controls.querySelectorAll('[data-jb-axis-field]')].find(field => field.dataset.jbAxisField === axis.key);
        if (old) {
          if (/^(shape|diamondType|carat|caratWeight|carat_weight)$/.test(axis.key)) {
            old.classList.add('jb-stone-option-field');
            old.querySelector('legend').textContent = axis.label;
          }
        } else {
          const original = controls.querySelector('[data-jb-axis-field="design"], [data-jb-axis-field="configuration"]');
          const field = fieldFor(axis, true);
          if (original) original.before(field); else controls.prepend(field);
        }
      });
      const keys = new Set(config.axes.map(axis => axis.key));
      controls.querySelectorAll('[data-jb-axis-field]').forEach(field => { if (!keys.has(field.dataset.jbAxisField)) field.remove(); });
      manifest.configuration = config; node.textContent = JSON.stringify(manifest); node.dataset.jbStonePrepared = 'true';
    });
  };
  const bridges = new WeakMap();
  const enhanceNative = info => {
    if (info.querySelector('[data-jb-catalog-controls]')) return;
    info.querySelectorAll('variant-selects fieldset[data-index]').forEach(native => {
      const key = native.dataset.handle || '';
      const isDesign = /^(design|configuration)$/.test(key);
      const isShape = /^(shape|diamond-shape|gemstone-shape)$/.test(key);
      const isCarat = /^(carat|carat-weight|caratweight)$/.test(key);
      if (!isDesign && !isShape && !isCarat) return;
      let bridge = bridges.get(native);
      if (bridge && bridge.container.isConnected) { bridge.sync(); return; }
      if (!isDesign && native.querySelector('.jb-wrapped-shape-buttons,.jb-five-stone-version-buttons')) return;
      const select = native.querySelector('select');
      const choices = [...(select ? select.options : native.querySelectorAll('input[type="radio"]'))].filter(choice => choice.value);
      if (!choices.length) return;
      const derived = isDesign ? normalize({ axes: [{ key: 'design' }], records: choices.map(choice => ({ design: choice.value, selections: { design: choice.value }, specs: {} })) }, labels) : null;
      const parsed = choices.map((choice,index) => isDesign ? derived.records[index].selections : { [isShape ? 'shape' : 'caratWeight']: choice.value });
      if (parsed.some(value => !value)) return;
      const keys = ['shape','caratWeight','length','version'].filter(axis => parsed.every(value => value[axis]));
      if (!keys.length) return;
      const container = document.createElement('div'); container.className = 'jb-stone-option-fields';
      const fields = keys.map(axis => {
        const values = [...new Set(parsed.map(value => value[axis]))].sort(axis === 'caratWeight' ? (a,b) => weight(a)-weight(b) : (a,b) => shapes.indexOf(a)-shapes.indexOf(b)).map(value => ({ value, label: value }));
        const field = fieldFor({ key: axis, label: labels[axis], values }, false); container.append(field); return field;
      });
      native.before(container); native.classList.add('jb-stone-option-source');
      const selectedIndex = () => Math.max(0, choices.findIndex(choice => select ? choice.selected : choice.checked));
      const available = choice => !choice.disabled && choice.dataset.available !== 'false';
      const sync = () => {
        const current = parsed[selectedIndex()];
        fields.forEach(field => field.querySelectorAll('button').forEach(button => {
          const axis = field.dataset.jbStoneKey;
          button.setAttribute('aria-pressed', String(current[axis] === button.dataset.jbValue));
          button.disabled = !choices.some((choice,index) => available(choice) && parsed[index][axis] === button.dataset.jbValue && (axis === 'shape' || !current.shape || parsed[index].shape === current.shape));
        }));
      };
      container.addEventListener('click', event => {
        const button = event.target.closest('button'); if (!button || button.disabled) return;
        const axis = button.closest('fieldset').dataset.jbStoneKey;
        const current = parsed[selectedIndex()];
        const candidates = choices.map((choice,index) => ({ choice, value: parsed[index] })).filter(item => available(item.choice) && item.value[axis] === button.dataset.jbValue && (axis === 'shape' || !current.shape || item.value.shape === current.shape));
        const next = candidates.find(item => keys.every(key => key === axis || item.value[key] === current[key])) || candidates[0];
        if (!next) return;
        if (select) select.value = next.choice.value; else next.choice.checked = true;
        const input = select || next.choice;
        input.dispatchEvent(new Event('input', { bubbles: true })); input.dispatchEvent(new Event('change', { bubbles: true })); sync();
      });
      native.addEventListener('change', sync);
      bridges.set(native, { container, sync }); sync();
    });
  };
  const start = () => {
    prepareCatalogs();
    document.querySelectorAll('.product-information--inner').forEach(enhanceNative);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('product:variant-change', start);
})();
